import { useState } from 'react';
import { InputSearch } from 'ui/inputs';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { SnippetListItem, SnippetListContainer, SnippetSearchListContainer } from './Styled';

import { GraphQLSnippet } from '../types';
import { useSnippetFiltersContext } from '../context/SnippetFiltersContext';

import { SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS } from '../constants';
import { useSnippets } from '../hooks/useSnippets';
import { SORT_DIRECTIONS } from '../../../constants/sortDirectionsEnum';

const content = {
  placeholderSearch: 'Search all snippets',
};

const LIMIT_SNIPPET_RESULT = 60;

type Props = {
  onSelectSnippet: (snippet: GraphQLSnippet) => void;
  selectedSnippet: GraphQLSnippet;
};

export const SnippetSearchList = ({ onSelectSnippet, selectedSnippet }: Props) => {
  const { searchQuery, setSearchQuery } = useSnippetFiltersContext();
  const [searchInputValue, setSearchInputValue] = useState(searchQuery);
  const { results: snippetList } = useSnippets(() => ({
    sort: { sortBy: 'UpdatedAt', sortDirection: SORT_DIRECTIONS.DESCENDING },
    pagination: { limit: LIMIT_SNIPPET_RESULT, offset: 0 },
    search: searchInputValue,
  }));

  useDebouncedEffect(() => setSearchQuery(searchInputValue), [searchInputValue], {
    skipEffectOnMount: true,
    debounceTimeout: SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS,
  });

  const handleSelectSnippet = (snippet: GraphQLSnippet) => {
    onSelectSnippet(snippet);
  };

  return (
    <SnippetSearchListContainer>
      <InputSearch
        id={'snippet-search'}
        onChange={(newVal: string) => {
          setSearchInputValue(newVal);
          setSearchQuery(newVal);
        }}
        placeholder={content.placeholderSearch}
        value={searchInputValue}
      />
      <SnippetListContainer>
        {snippetList &&
          snippetList.map((snippet: GraphQLSnippet, i) => {
            return (
              <SnippetListItem
                key={i}
                isSelected={selectedSnippet.id === snippet.id}
                onClick={() => {
                  handleSelectSnippet(snippet);
                }}
              >
                {snippet.name}
              </SnippetListItem>
            );
          })}
      </SnippetListContainer>
    </SnippetSearchListContainer>
  );
};
